export const VERIFICATION_FIELDS = [
  { name: 'Dealership', dbKey: 'dealership' },
  { name: 'Make Model Year', dbKey: 'make_model_year' },
  { name: 'Image url', dbKey: 'image_url' },
  { name: 'Verification source', dbKey: 'verification_source' },
  { name: 'Verification Id', dbKey: 'verification_id' },
  { name: 'Verification timestamp', dbKey: 'verification_timestamp' },
  { name: 'Passed checks', dbKey: 'passed_checks' }
];
